import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SupplyRequest } from '../../models/ocl';
import { UrlProviderService } from '../general';

@Injectable({
    providedIn: 'root',
})
export class SupplyService {

    constructor(private urlProviderService: UrlProviderService, private httpClient: HttpClient) {
    }

    public sendEmail(supply: SupplyRequest): Observable<any> {
        return this.httpClient.post<any>(`${this.urlProviderService.ApiUrl}/system/supplies/email`, supply,
            {reportProgress: true});
    }
}
